<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="d-flex justify-content-between flex-wrap gap-2 align-items-center my-2">

        <!-- Page Title -->
        <div>
          <h5 class="d-flex align-items-center mb-0">
            <i class="fa fa-list text-primary"></i>
            <p class="wrap-text mb-0 ms-2">
              {{ 'USECASEDATABASE.DATABASE_USER' | translate }}
            </p>
          </h5>
        </div>

        <!-- Pagination top -->
        <div>
          <app-list-header [$parent]="getSelf()"></app-list-header>
        </div>

      </div>
    </div>

    <div class="col-md-12 mt-3">
      <div class="card">
        <div class="card-body">
          <div class="compact-inputs dropdown-pd-none">
            <div class="row g-2 align-items-center">

              <!-- Search: Login -->
              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>
                        {{ 'applicationUsers.search.placeholder' | translate }}
                      </mat-label>
                      <input matInput type="text" [(ngModel)]="searchText" />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="'applicationUsers.search.placeholder' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact">info</mat-icon>
                  </button>
                </div>
              </div>

              <!-- Search: Login Code -->
              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>
                        {{ 'ALLREMAININGS.Enter_LOGin_Code' | translate }}
                      </mat-label>
                      <input matInput type="text" [(ngModel)]="searchLogicCode" />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="'ALLREMAININGS.Enter_LOGin_Code' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact">info</mat-icon>
                  </button>
                </div>
              </div>

              <!-- Search: Mobile -->
              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>
                        {{ 'ALLREMAININGS.Enter_Mobile_id' | translate }}
                      </mat-label>
                      <input matInput type="number" [(ngModel)]="searchMobile" />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="'ALLREMAININGS.Enter_Mobile_id' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact">info</mat-icon>
                  </button>
                </div>
              </div>

              <!-- Search + Reset buttons -->
              <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12">
                <div class="d-flex align-items-center">
                  <button
                    mat-stroked-button
                    color="primary"
                    class="me-3"
                    (click)="searchUsers()"
                  >
                    <mat-icon>search</mat-icon>
                    <span>{{ 'applicationUsers.search.buttons.search' | translate }}</span>
                  </button>
                  <button
                    mat-stroked-button
                    color="warn"
                    (click)="resetFilters()"
                  >
                    <i class="fa fa-eraser eraser-warn-dark"></i>
                    <span class="ms-2">{{ 'applicationUsers.search.buttons.reset' | translate }}</span>
                  </button>
                </div>
              </div>

              <!-- Table -->
              <div class="mt-3 pt-1">
                <div class="table-container">
                  <div class="table-responsive table-scrollable">
                    <table class="table table-bordered table-hover table-sticky-header">
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 5%">
                            {{ 'applicationUsers.table.headers.sno' | translate }}
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span class="header-label" (click)="sortTable('loginId')">
                              {{ 'ALLREMAININGS.Login' | translate }}
                              <ng-container *ngTemplateOutlet="sortIcons; context: { key: 'loginId' }"></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span class="header-label" (click)="sortTable('roleName')">
                              {{ 'applicationUsers.table.headers.role' | translate }}
                              <ng-container *ngTemplateOutlet="sortIcons; context: { key: 'roleName' }"></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span class="header-label" (click)="sortTable('loginCode')">
                              {{ 'ALLREMAININGS.Login_Code' | translate }}
                              <ng-container *ngTemplateOutlet="sortIcons; context: { key: 'loginCode' }"></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span class="header-label" (click)="sortTable('mobileId')">
                              {{ 'ALLREMAININGS.Mobile_Id' | translate }}
                              <ng-container *ngTemplateOutlet="sortIcons; context: { key: 'mobileId' }"></ng-container>
                            </span>
                          </th>
                        </tr>

                        <!-- Sort icon template -->
                        <ng-template #sortIcons let-key="key">
                          <i *ngIf="sortedField === key && sortOrder === 'ASC'"
                            class="fa fa-sort-up ms-1 text-dark"></i>
                          <i *ngIf="sortedField === key && sortOrder === 'DESC'"
                            class="fa fa-sort-down ms-1 text-dark"></i>
                          <i *ngIf="sortedField !== key"
                            class="fa fa-sort ms-1 text-muted"></i>
                        </ng-template>
                      </thead>

                      <tbody>
                        <tr *ngFor="let e of UserList; let i = index">
                          <td class="text-center" style="width: 5%">{{ pageIndex(i) }}</td>
                          <td>{{ e.loginId }}</td>
                          <td>{{ e.roleName }}</td>
                          <td>{{ e.loginCode }}</td>
                          <td>{{ e.mobileId }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Pagination bottom -->
                <div class="mt-4">
                  <app-list-header [$parent]="getSelf()"></app-list-header>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>